/**
 * Session storage keys used to suppress stale post-action account reactivation UI.
 */
export class AccountReactivationStorage {
    public static readonly RESUME_RELOAD_PENDING_KEY = 'account-reactivation.resume-pending';
    public static readonly PAYMENT_RECOVERY_PENDING_KEY = 'account-reactivation.payment-recovery-pending';

    /**
     * Returns the session storage key used to suppress stale paused-state UI after resume.
     */
    public static getResumeReloadStorageKey( userId: string ): string {
        return `${ AccountReactivationStorage.RESUME_RELOAD_PENDING_KEY }:${ userId }`;
    }

    /**
     * Returns the session storage key used to suppress stale payment recovery UI after opening billing.
     */
    public static getPaymentRecoveryStorageKey( userId: string ): string {
        return `${ AccountReactivationStorage.PAYMENT_RECOVERY_PENDING_KEY }:${ userId }`;
    }
}
